import * as Yup from "yup";

export const dataModel = {
  locationUuid: "",
  name: "",
  rowsAB: false,
  rows: "",
  active: false,
};

export const validationDataModel = (edit) => {
  if (edit) {
    return Yup.object().shape({
      locationUuid: Yup.string().required("forms.validations.required"),
      name: Yup.string().required("forms.validations.required"),
      rowsAB: Yup.boolean().required("forms.validations.required"),
      rows: Yup.number().required("forms.validations.required"),
      active: Yup.boolean().required("forms.validations.required"),
    });
  }

  return Yup.object().shape({
    locationUuid: Yup.string().required("forms.validations.required"),
    name: Yup.string().required("forms.validations.required"),
    rowsAB: Yup.boolean().required("forms.validations.required"),
    rows: Yup.number().required("forms.validations.required"),
    active: Yup.boolean().required("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
